import * as React from 'react';
import { Context } from '../components/Provider';
import { mergeClassNames } from './mergeClassNames';

export const useProps = <Props>(props: Props) => {
  const { underscoreClassesTransform } = React.useContext(Context);

  return mergeClassNames(props, { underscoreClassesTransform });
};
